import { useEffect } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import Logo from "./Logo";
import { EASE } from "./Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Revathy+Stores%2C+61+B%2F5%2C+A.V.+Church+Road%2C+Vannandurai%2C+Besant+Nagar%2C+Chennai+600090";

const Nav = () => {
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("site-nav");
      if (!el) return;
      el.style.boxShadow =
        window.scrollY > 24 ? "0 1px 0 rgba(255,255,255,0.06)" : "none";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      id="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#0a0a0a]/60 backdrop-blur-xl"
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-8">
        <Logo />
        <div className="hidden items-center gap-10 md:flex">
          <a
            href="#collection"
            data-testid="nav-shelves-link"
            className="font-mono text-xs uppercase tracking-[0.22em] text-stone-400 transition-colors hover:text-brand-brass"
          >
            The Shelves
          </a>
          <a
            href="#visit"
            data-testid="nav-visit-link"
            className="font-mono text-xs uppercase tracking-[0.22em] text-stone-400 transition-colors hover:text-brand-brass"
          >
            Visit
          </a>
        </div>
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-directions-btn"
          className="group inline-flex items-center gap-2 rounded-full bg-brand-brass px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-ink transition-all duration-300 hover:bg-brand-brass-hover hover:shadow-[0_0_24px_rgba(212,175,55,0.35)] md:px-5 md:py-2.5"
        >
          <MapPin className="h-3.5 w-3.5" />
          Get Directions
        </a>
      </nav>
    </motion.header>
  );
};

export default Nav;
